var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000000;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zas\xF3b 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dziekujemy"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25 1.72 23.28 0 12.5 10.78 1.72 0 0 1.72 10.78 12.5 0 23.28 1.72 25 12.5 14.22 23.28 25 25 23.28 14.22 12.5 25 1.72"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d8e921905a821bfbd1b5a7c699acef9d.svg";
export { ForwardRef as ReactComponent };